export const NAME = 'Content View Trigger';

export const ID = 'b750cdbd-e4b1-4bc0-b2c0-10a77e5a64c8';
